import Description from './Description';
import TrustMarkers from './TrustMarkers';

function Section2() {
  return (
    <div className="">
      <div className="flex flex-col   md:py-[100px]  justify-center">
     
        <div>
          <TrustMarkers />
        </div>
        <div>
          <Description />
        </div>
      </div>
    </div>
  );
}

export default Section2;
